import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";
import * as Common from './../../Common';
import Dialog from './../../Dialog';

function Rep_dashboard() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [filterLocationType, setFilterLocationType] = useState("A");
    const [filterLocation, setFilterLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);

    const [summary, setSummary] = useState({
        total_transactions: 0,
        total_inr: 0,
        total_usd: 0,
        total_profit: 0
    });
    const [productRows, setProductRows] = useState([]);
    const [branchRows, setBranchRows] = useState([]);
    const [txnTypeRows, setTxnTypeRows] = useState([]);
    const [isdRows, setIsdRows] = useState([]);
    const [purposeRows, setPurposeRows] = useState([]);
    const [saleReloadRows, setSaleReloadRows] = useState([]);
    const [comboRows, setComboRows] = useState([]);

    const fmt0 = (v) => Common.formatNumberDisplay(Math.round(Number(v || 0)));

    useEffect(() => {
        if (onceRun) return;

        Common.getActiveBranch().then(response => {
            setFilterLocation(response);
            if (response && filterLocationType === 'O') {
                const loc = response.id.split('^');
                setLocationCode(loc[1]);
            }
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRANSACTION_REPORT'], function (result) {
            const resp = JSON.parse(result);
            if (+resp.query === 1) {
                setUserRight(resp);
            } else {
                Common.callApi(Common.apiRight, [sid, 'all', 'REP_PROFITABILITY_TRANSACTION'], function (result2) {
                    const resp2 = JSON.parse(result2);
                    if (+resp2.query === 1) {
                        setUserRight(resp2);
                    } else {
                        navigate('/');
                    }
                });
            }
        });

        setOnceRun(true);
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFilterLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    };

    const loadDashboard = () => {
        if (filterLocationType === 'O' && filterLocation === null) {
            let msg = [];
            msg.push(Common.getMessage("MSG0006"));
            if (filterLocationType === 'O' && filterLocation === null) msg.push("Select Location.");
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            return;
        }

        const obj = {
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            filterLocationType: filterLocationType,
            locationCode: locationCode
        };

        $(".loader").show();
        Common.callApi(Common.apiRepDashboard, [sid, 'dashboard', JSON.stringify(obj)], function (result) {
            $(".loader").hide();
            const resp = JSON.parse(result);
            if (resp.status === "MSG0002") {
                navigate('/');
                return;
            }
            if (resp.status === "ERR") {
                setMsgText(resp.msg || "Unable to load dashboard.");
                setMsgBox(true);
                return;
            }
            setSummary(resp.summary || summary);
            setProductRows(resp.by_product || []);
            setBranchRows(resp.by_branch || []);
            setTxnTypeRows(resp.by_transaction_type || []);
            setIsdRows(resp.by_isd || []);
            setPurposeRows(resp.by_purpose || []);
            setSaleReloadRows(resp.by_sale_reload || []);
            setComboRows(resp.by_product_branch || []);
        });
    };

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col><h3>MIS Dashboard</h3></Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={filterLocationType} onChange={(e) => setFilterLocationType(e.target.value)}>
                                <option value="O">One</option>
                                <option value="A">All</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {filterLocationType === 'O' ?
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={filterLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                />
                            </Form.Group>
                        </Col> : null}
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>From Date</Form.Label><br />
                            <DatePicker className="form-control"
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>To Date</Form.Label><br />
                            <DatePicker className="form-control"
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={loadDashboard}>
                            Generate Dashboard
                        </Button>
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col md={3}><Card body><b>Total Transactions</b><div>{fmt0(summary.total_transactions)}</div></Card></Col>
                    <Col md={3}><Card body><b>Total INR</b><div>{fmt0(summary.total_inr)}</div></Card></Col>
                    <Col md={3}><Card body><b>Total USD</b><div>{fmt0(summary.total_usd)}</div></Card></Col>
                    <Col md={3}><Card body><b>Total Profit</b><div>{fmt0(summary.total_profit)}</div></Card></Col>
                </Row>

                <Row className='mt-3'>
                    <Col md={5}>
                        <h5>Product Summary</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Transactions</th>
                                    <th>INR</th>
                                    <th>USD</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.product}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_usd)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                    <Col md={7}>
                        <h5>Branch Summary</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Branch</th>
                                    <th>Transactions</th>
                                    <th>INR</th>
                                    <th>USD</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {branchRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.branch_code} {row.branch_name}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_usd)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={6}>
                        <h5>Transaction Type Summary</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Transactions</th>
                                    <th>INR</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {txnTypeRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.transaction_type}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                    <Col md={6}>
                        <h5>Sale / Reload Summary</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Category</th>
                                    <th>Transactions</th>
                                    <th>INR</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {saleReloadRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.sale_or_reload === '' ? 'NA' : row.sale_or_reload}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={6}>
                        <h5>ISD Summary</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>ISD</th>
                                    <th>Transactions</th>
                                    <th>Value(ISD)</th>
                                    <th>INR</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isdRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.isd_code}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_isd)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                    <Col md={6}>
                        <h5>Purpose Summary</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Purpose</th>
                                    <th>Transactions</th>
                                    <th>INR</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {purposeRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.purpose_code} {row.purpose_name}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <h5>Top Product x Branch x Type (by INR)</h5>
                        <Table bordered hover size='sm'>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Branch</th>
                                    <th>Type</th>
                                    <th>Transactions</th>
                                    <th>INR</th>
                                    <th>Profit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {comboRows.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.product}</td>
                                        <td>{row.branch_code} {row.branch_name}</td>
                                        <td>{row.transaction_type}</td>
                                        <td>{fmt0(row.total_transactions)}</td>
                                        <td>{fmt0(row.total_inr)}</td>
                                        <td>{fmt0(row.total_profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={() => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </>
    );
}

export default Rep_dashboard;
